import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TeamsService } from 'src/app/services/crew-services/teams.service';
import { DealsService } from 'src/app/services/deals.service';
import { OrganizationService } from 'src/app/services/organizationservice';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { LogActivityService } from 'src/app/services/settings-services/log-activity.service';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.css']
})
export class LeaderboardComponent implements OnInit {
  default_team_id: any;
  all_salespersons: any = {};
  salespersons: any = [];

  leaderboard_by_amount: any = {};
  leaderboard_by_count: any = {};

  constructor(
    private activity_logs_service: LogActivityService,
    private team_service: TeamsService,
    private organisation_service: OrganizationService,
    private deal_service: DealsService,
    private reports_service: PerformanceReportService,
    private store: Store<AppState>
  ) {
    this.store.select('userInfo').subscribe(info => {
      this.default_team_id = info.user.teamID;
    });
  }

  ngOnInit() {
    this.reports_service.selected_users.subscribe(info => {
      if (info && info.type == 'team') {
        this.fetchDeals(0, 999999999999999, info.ids);
      }
    });

    this.organisation_service.getUsersInOrganization(5).subscribe(users => {
      this.all_salespersons = users.reduce((sps, user) => {
        return {
          ...sps,
          [user.id]: user
        }
      }, {});
    });
  }

  fetchSalespersons(team_id?: number) {
    team_id = team_id || this.default_team_id;
    this.team_service.fetchTeamMembers(team_id).subscribe((response: any) => {
      this.salespersons = response.map(salesperson => {

        this.leaderboard_by_amount[salesperson.salesPersonID] = 0;
        this.leaderboard_by_count[salesperson.salesPersonID] = 0;

        return {
          ...this.all_salespersons[salesperson.salesPersonID],
        }
      });
    });
  }

  fetchDeals(from: number = Number.MIN_SAFE_INTEGER, to: number = Number.MAX_SAFE_INTEGER, team_ids?: Array<number>) {
    this.deal_service.fetchDeals(team_ids, { dateFilter: { endDate: to, startDate: from } }).subscribe(response => {

    });
  }

  sortDealsBySalesperson(deals: Array<any>) {
    deals.forEach(deal => {
      const { amount, status, creatorID, teamID } = deal;
    });
  }
}
